import { RootState } from '@features/store';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { LoginResponse, Operator } from '@services';

export type AuthState = {
    isLogged: boolean;
    user: Omit<LoginResponse, 'operators'> | null;
    operators: Operator[] | null;
    fcmToken: string | null;
};

const initialAuthState: AuthState = {
    isLogged: false,
    user: null,
    operators: null,
    fcmToken: null
};

export const authSlice = createSlice({
    name: 'authentication',
    initialState: initialAuthState,
    reducers: {
        login: (state, action: PayloadAction<LoginResponse>) => {
            const { operators, ...userData } = action.payload;
            state.isLogged = true;
            state.user = userData;
            state.operators = operators;
        },
        logout: (state) => {
            state.isLogged = false;
            state.user = null;
            state.operators = null;
            state.fcmToken = null;
        },
        updateFcmToken: (state, action: PayloadAction<string>) => {
            state.fcmToken = action.payload;
        },
        updateSignature: (state, action: PayloadAction<string>) => {
            if (state.user) {
                state.user.signature = action.payload;
            }
        }
    }
});
export const getIsLogged = (state: RootState) => state.authentication.isLogged;
export const getUser = (state: RootState) => state.authentication.user;
export const getFirstname = (state: RootState) => state.authentication.user?.first_name;
export const getSignature = (state: RootState) => state.authentication.user?.signature;
export const getWorksites = (state: RootState) => state.authentication.operators?.flatMap((operator) => operator.worksites);
export const getWorksiteById = (id: string) => (state: RootState) =>
    state.authentication.operators?.flatMap((operator) => operator.worksites).find((worksite) => worksite.id === id);
export const getFcmToken = (state: RootState) => state.authentication.fcmToken;

export const { login, logout, updateFcmToken, updateSignature } = authSlice.actions;

export default authSlice.reducer;
